module.exports = __webpack_public_path__ + "static/media/demo-final-image.46fc5ccb.png";